import React from "react";

import Item from "../Item";

import pianduan from "../../assets/img/pianduan.png";

import column from "../../assets/img/column.png";

import "./index.scss";

import Column from "../Column";

import useStore from "../../store";

import { observer } from "mobx-react-lite";

const List = (props) => {
  const { listStore } = useStore();

  const listData = listStore.getList();

  return (
    <div className="List">
      <div className="Bg">
        <div className="Bt">
          <img src={pianduan} alt="精彩视频" />
        </div>
        <div className="ItemBox">
          {listData.map((item) => (
            <Item
              imgSrc={item.img}
              title={item.title}
              link={item.link}
              src={item.src}
              id={item.id}
              key={item.id}
              onPortal={props.onPortal}
              onTemp={props.onTemp}
              onWheel={props.onWheel}
            />
          ))}
        </div>
        <div className="Bt">
          <img src={column} alt="精彩视频" />
        </div>
        <Column />
      </div>
    </div>
  );
};

export default observer(List);
